<script lang="ts">
    import { onMount } from 'svelte';
    import Select from 'svelte-select';
    import Product from '../../Models/Product';
    import { LATEST_ADDED_PRODUCT, LATEST_EDITED_PRODUCT } from '../../Stores/Product';
    import { CURRENT_PURCHASE_PRODUCT, LATEST_PURCHASE } from '../../Stores/Purchase';

    let items;
    let unremovedProducts = [];
    let value;

    function handleSelect(e) {
        const selectedProduct = e.detail;
        CURRENT_PURCHASE_PRODUCT.set(selectedProduct);
    }

    LATEST_PURCHASE.subscribe(clearChoice);

    LATEST_ADDED_PRODUCT.subscribe(getProducts);

    LATEST_EDITED_PRODUCT.subscribe(() => {
        getProducts();
        clearChoice();
    });

    onMount(getProducts);

    function clearChoice() { 
        CURRENT_PURCHASE_PRODUCT.set({  })
        value = null;
    }

    async function getProducts() {
        const res = await Product.get();
        if (res) {
            unremovedProducts = [];
            res.forEach(product => {
                const { _id, discount, name, price, removed } = product;
                if (!removed) {
                    unremovedProducts.push({
                        value: _id,
                        discount,
                        label: name,
                        price
                    });
                }
            })
            items = unremovedProducts;
            items.sort((a, b) => a.label.localeCompare(b.label));
        }
    }
</script>

{#if items}
    <Select on:select={handleSelect} bind:value {items} placeholder="Wybierz produkt" noOptionsMessage="Brak produktów w bazie" containerStyles="width: 350px"></Select>
{/if}